class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-count-badge');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    var currentPath = window.location.pathname;
    
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();

      const cartLinkClicked = true;
      
      // const scrollPosition = window.scrollY;
      // const drawer = document.querySelector('cart-drawer.drawer');

      // console.log({scrollPosition})

      // if (scrollPosition <= 45) {
      //   const eee = 45 - scrollPosition;
      //   console.log({scrollPosition, eee})
      //   drawer.style.top = `${eee / 10}rem`;
      //   drawer.style.height = `calc(100% - ${eee / 10}rem)`;
      // } else {
      //   drawer.style.top = '0px';
      //   drawer.style.height = `100%`;
      // }
      
      // drawer.classList.add('animate', 'active');
      
      if (currentPath === "/cart") {
        window.location.reload();
        return;
      } else {
        this.open(cartLink, cartLinkClicked); 
      }
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        if (currentPath === "/cart") {
          window.location.reload();
          return;
        } else {
          this.open(cartLink); 
        }
      }
    });
  }

  open(triggeredBy, cartLinkClicked) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    const gratsLoader = this.querySelector('.grats .loading__spinner');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    const delayBasedOnTarget = triggeredBy ? 0 : 420;


    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      const scrollPosition = window.scrollY;
      const drawerOpenOnAdd = this.classList.contains('open-on-add');

      if (scrollPosition <= 45) {
        const eee = 45 - scrollPosition;
        this.style.top = `${eee / 10}rem`;
        this.style.height = `calc(100% - ${eee / 10}rem)`;
      } else {
        this.style.top = '0px';
        this.style.height = `100%`;
      }
      

      if(drawerOpenOnAdd || cartLinkClicked) {
        this.classList.remove('lowIndex');
        this.classList.add('animate', 'active');
        gratsLoader?.classList.add('active');
      }
    }, delayBasedOnTarget);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if(cartLinkClicked) {
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    const gratsLoader = this.querySelector('.grats .loading__spinner');
    this.classList.remove('active');
    setTimeout(() => {
      this.classList.add('lowIndex');
      this.classList.remove('animate');
      gratsLoader?.classList.remove('active');
    }, 300);
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      if(section.selector) {
        const secEl = document.querySelector(section.selector);
        secEl.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      } else {
        const secEl = document.getElementById(section.id);
        secEl.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    const dd = document.querySelector('.new-count');
    const eee = document.querySelectorAll('cart-drawer form quantity-input input.quantity__input');
    const totalQuantity = Array.from(eee).reduce((total, input) => total + parseInt(input.value) || 0, 0);
    
    if(totalQuantity > 0) {
      dd.classList.remove('empty');

      if(totalQuantity > 99) {
        dd.classList.add('way-more');
      }

      dd.classList.add('bounce');
      setTimeout(() => {
        dd.classList.remove('bounce');
      }, 360);
    }

    if(totalQuantity < 100) {
      dd.classList.remove('way-more');
    }
    
    dd.innerHTML = totalQuantity < 100 ? totalQuantity : '99+';

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
